import { Component, TemplateRef, ViewChild, Input, OnInit } from '@angular/core';
import { Tarea } from '../../../interfaces/tarea';
import * as moment from 'moment';
import { NotificationsService, Notification, NotificationType } from 'angular2-notifications';
import { Router } from '@angular/router';

@Component({
  selector: 'app-tarea-notificacion',
  templateUrl: './tarea-notificacion.component.html',
  styleUrls: ['./tarea-notificacion.component.scss']
})
export class TareaNotificacionComponent implements OnInit {
  titulo: string;
  contenido: string;
  @Input() tarea: Tarea;
  private _notificacion: Notification;

  @ViewChild('templateTareaNotificacion') templateTareaNotificacion: TemplateRef<any>;

  constructor(
    private router: Router,
    private notificationsService: NotificationsService
  ) { }

  ngOnInit(): void {
    this.titulo = moment(this.tarea.fechaTarea, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm') + 'hs';
    this.contenido = this.tarea.titulo;

    this._notificacion = this.notificationsService.html(
      this.templateTareaNotificacion,
      NotificationType.Info,
      {
        timeOut: 0,
        showProgressBar: false,
        pauseOnHover: true,
        clickToClose: true,
        maxLength: 10,
        animate: "fromLeft",
        id: `tarea${new Date().getTime()}`
      }
    );

    // On click a la notificacion ir a la tarea
    this._notificacion.click.subscribe((e: MouseEvent) => {
      this.router.navigate(['logueado/tarea-detalle/', this.tarea.IdTarea]);
    });
  }

  cerrarNotificacion() {
    this.notificationsService.remove(this._notificacion.id);
  }
}
